import React, { Component } from "react";
import { toast } from "react-toastify";
import ApiConnect from "../../../../Utils/ApiConnect";
import { connect } from "react-redux";
import { AccountGroups } from "../../../../redux/actions/Modules.Action";
class AddAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myFData: [],
      btnDisable: false,
    };
  }
  componentDidMount = () => {
    ApiConnect.get("/Module/Accounts/AccountHead/GroupDetails")
      .then((response) => {
        this.props.AccountGroups(response.data);
      })
      .catch((error) => console.log(error));
  };
  handleChange(e) {
    const newFdata = { ...this.state.myFData };
    newFdata[e.target.name] = e.target.value;
    this.setState({ myFData: newFdata });
  }
  handleFormSubmit(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdatas = new FormData();
    Fdatas.append("name", this.state.myFData.name);
    Fdatas.append("contact", this.state.myFData.contact);
    Fdatas.append("address", this.state.myFData.address);
    Fdatas.append("email", this.state.myFData.email);
    Fdatas.append("vat", this.state.myFData.vat);
    Fdatas.append("group", this.state.myFData.group);
    Fdatas.append("limit", this.state.myFData.limit);
    Fdatas.append("docs", this.state.myFData.docs);
    ApiConnect({
      method: "post",
      url: "/Module/Accounts/AccountHead/NewAccount",
      data: Fdatas,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        console.log(response);
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          this.setState({
            myFData: [],
            formError: false,
          });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.fetchAccountDetails();
        } else if (response.data.status) {
          toast.danger(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  }
  render() {
    return (
      <div className="card">
        <div className="card-header">
          <h5 className="modal-title">New Account Head</h5>
        </div>
        <form onSubmit={(e) => this.handleFormSubmit(e)}>
          <div className="card-body">
            <p className="text-danger">{this.state.formError}</p>
            <div className="row form-group">
              <div className="col">
                <label className="form-label">Account Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  required
                  value={this.state.myFData.name || ""}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
              <div className="col">
                <label className="form-label">Contact</label>
                <label className="col-12">
                  <input
                    type="number"
                    name="contact"
                    required
                    className="form-control"
                    value={this.state.myFData.contact || ""}
                    onChange={(e) => this.handleChange(e)}
                  />
                </label>
              </div>
            </div>
            <div className="row form-group">
              <div className="col">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  name="address"
                  required
                  className="form-control"
                  value={this.state.myFData.address || ""}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
              <div className="col">
                <label className="form-label">Email</label>
                <label className="col-12">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={this.state.myFData.email || ""}
                    onChange={(e) => this.handleChange(e)}
                  />
                </label>
              </div>
            </div>
            <div className="row form-group">
              <div className="col">
                <label className="form-label">VAT/PAN</label>
                <input
                  type="number"
                  name="vat"
                  required
                  className="form-control"
                  value={this.state.myFData.vat || ""}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
              <div className="col">
                <label className="form-label">Account Group</label>
                <label className="col-12">
                  <select
                    className="form-control"
                    name="group"
                    required
                    onChange={(e) => this.handleChange(e)}
                    value={this.state.myFData.group || ""}
                  >
                    <option value="">---Select Group----</option>
                    {this.props.AccountGroupData.map((grp, index) => (
                      <option value={grp.id} key={index}>
                        {grp.name} | {grp.group}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
            <div className="row form-group">
              <div className="col">
                <label className="form-label">Account Limit</label>
                <input
                  type="number"
                  name="limit"
                  required
                  className="form-control"
                  value={this.state.myFData.limit || 0}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
              <div className="col">
                <label className="form-label">Docs</label>
                <label className="col-12">
                  <input
                    type="file"
                    name="docs"
                    className="form-control"
                    value={this.state.myFData.docs || ""}
                    onChange={(e) => this.handleChange(e)}
                  />
                </label>
              </div>
            </div>
          </div>
          <button
            type="submit"
            className="btn btn-success"
            disabled={this.state.btnDisable}
          >
            Create
          </button>
        </form>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    AccountGroupData: state.Accounts.AccountGroup,
  }),
  { AccountGroups }
)(AddAccount);
